<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="chaptertitle1"><i>Contents</i></p>
<p class="toc"><i><a href="#/foreword">Foreword</a> by Paula Newby-Fraser</i></p>
<p class="toc"><a href="#/ack"><i>Acknowledgments</i></a></p>
<p class="noindent"> </p>
<p class="toc1">     <a href="#/introduction"><span class="color_s1">|</span> <b>Introduction</b></a></p>
<p class="toc3b">       <a href="#/introduction"><i>Evolution to a Running Revolution</i></a></p>
<p class="toc3">  <a href="#/chap01"><b><span class="color_s1">1 |</span> What Is Natural Running?</b></a></p>
<p class="toc3">  <span href="#/chap02" title="Link target outside of Sample"><b><span class="color_s1">2 |</span> Evolution of a Sport and a Shoe</b></span></p>
<p class="toc3">  <span href="#/chap03" title="Link target outside of Sample"><b><span class="color_s1">3 |</span> Into the Lab</b></span></p>
<p class="toc3b">       <span href="#/chap03" title="Link target outside of Sample"><i>Examining Your Running Form</i></span></p>
<p class="toc3">  <span href="#/chap04" title="Link target outside of Sample"><b><span class="color_s1">4 |</span> The Science of Motion</b></span></p>
<p class="toc3b">       <span href="#/chap04" title="Link target outside of Sample"><i>Three Gaits</i></span></p>
<p class="toc3">  <span href="#/chap05" title="Link target outside of Sample"><b><span class="color_s1">5 |</span> Foot Biomechanics</b></span></p>
<p class="toc3b">       <span href="#/chap05" title="Link target outside of Sample"><i>A Close Examination</i></span></p>
<p class="toc3">  <span href="#/chap06" title="Link target outside of Sample"><b><span class="color_s1">6 |</span> The Physics of Running</b></span></p>
<p class="toc3b">       <span href="#/chap06" title="Link target outside of Sample"><i>Whole-Body Kinematics</i></span></p>
<p class="toc3">  <span href="#/chap07" title="Link target outside of Sample"><b><span class="color_s1">7 |</span> A New Way to Look at Common Running Injuries</b></span></p>
<p class="toc3">  <span href="#/chap08" title="Link target outside of Sample"><b><span class="color_s1">8 |</span> Natural Running, Unnatural World</b></span></p>
<p class="toc3">  <span href="#/chap09" title="Link target outside of Sample"><b><span class="color_s1">9 |</span> Dynamic Strength and Form Drills</b></span></p>
<p class="toc3a"><span href="#/chap10" title="Link target outside of Sample"><b><span class="color_s1">10 |</span> Natural Running</b></span></p>
<p class="toc3b">       <span href="#/chap10" title="Link target outside of Sample"><i>An Eight-Week Transition Plan</i></span></p>
<p class="toct"><span href="#/resources" title="Link target outside of Sample"><i>Resources</i></span></p>
<p class="toc"><span href="#/index" title="Link target outside of Sample"><i>Index</i></span></p>
<p class="toc"><span href="#/about_the_author" title="Link target outside of Sample"><i>About the Authors</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?f48be0d2